import { LOCATION_ETAT_RESERVATION } from "../utilities/Constants"

export const validateLocation = (data) => {
	const errors = []

	const addError = (message) => {
		errors.push(message)
	}

	// dateDebut
	if (!data.dateDebut || !/^\d{4}-\d{2}-\d{2}$/.test(data.dateDebut)) {
		addError("Date de location requise")
	}

	// heureDebut
	if (!data.heureDebut || !/^\d{2}:\d{2}$/.test(data.heureDebut)) {
		addError("Heure de location requise")
	}

	// nbJours
	if (
		data.nbJours === undefined ||
		data.nbJours === null ||
		isNaN(data.nbJours) ||
		data.nbJours === ""
	) {
		addError("Nombre de jours prévus requis")
	}
	if (data.vehicule === 0) errors.push("Sélectionner un véhicule de location")

	if (data.etat > LOCATION_ETAT_RESERVATION) {
		// dateFin (optionnel mais validé si présent)
		if (data.dateFin && !/^\d{4}-\d{2}-\d{2}$/.test(data.dateFin)) {
			addError("Date de restitution requise")
		}

		// heureFin (optionnel mais validé si présent)
		if (data.heureFin && !/^\d{2}:\d{2}$/.test(data.heureFin)) {
			addError("Heure de restitution requise")
		}

		// kms_avant
		// if (
		// 	data.kms_avant === undefined ||
		// 	data.kms_avant === null ||
		// 	isNaN(data.kms_avant) ||
		// 	data.kms_avant === "" ||
		// 	data.kms_avant === 0
		// ) {
		// 	addError("Kms avant requis")
		// }

		// tarifJourna
		if (
			data.tarifJourna === undefined ||
			data.tarifJourna === null ||
			isNaN(data.tarifJourna) ||
			data.tarifJourna === ""
		) {
			addError("Tarif journalier requis")
		}

		// superRefine — conditionnel is_assurance
		if (data.is_assurance) {
			if (!data.assurance || data.assurance === 0) {
				addError("Assurance requise")
			}
			if (!data.nRef || data.nRef === "") {
				addError("Numéro de référence requis")
			}
		}
	}

	return errors
}

export const validateLocationConducteurs = (data) => {
	const errors = []
	if (data.length === 0) return ["Ajouter au moins un conducteur"]
	const addError = (i, message) => {
		errors.push(`Conducteur #${i + 1} - ${message}`)
	}
	data.forEach((cond, i) => {
		if (cond.nom === "") addError(i, "Nom")
		if (cond.prenom === "") addError(i, "Prénom")
		if (cond.tel === "") addError(i, "Téléphone")
		if (cond.adresse === "") addError(i, "Adresse")
		if (cond.permis === "") addError(i, "Permis")
		if (cond.numeroPermis === "") addError(i, "Numéro du permis")
		if (
			!cond.dateNaissance ||
			!/^\d{4}-\d{2}-\d{2}$/.test(cond.dateNaissance)
		) {
			addError(i, "Date de naissance")
		}
		if (!cond.datePermis || !/^\d{4}-\d{2}-\d{2}$/.test(cond.datePermis)) {
			addError(i, "Date d'obtention du permis")
		}
	})

	return errors
}
